import { createAuth } from "@redotech/redo-customer-portal-app/api";
import {
  AuthContext,
  SetAuthContext,
} from "@redotech/redo-customer-portal-app/contexts/auth";
import { SettingsContext } from "@redotech/redo-customer-portal-app/contexts/settings";
import { CreateReturn } from "@redotech/redo-customer-portal-app/create-return/return";
import { memo, useContext, useEffect, useState } from "react";
import { BackHandlerContext } from "../contexts/BackHandlerContext";

export const RegisterWarranty = memo(function RegisterWarranty() {
  const settings = useContext(SettingsContext);
  const { setBackHandler } = useContext(BackHandlerContext);
  const [loaded, setLoaded] = useState(false);

  const authContext = useContext(AuthContext);
  const setAuthContext = useContext(SetAuthContext);
  useEffect(() => {
    if (!authContext) {
      void createAuth({ type: "orderless" }).then(({ token }) => {
        // @ts-expect-error: strict-null-checks
        setAuthContext(token);
        setLoaded(true);
      });
    } else {
      setLoaded(true);
    }
  }, [authContext, setAuthContext]);

  if (!loaded) {
    return null;
  }

  // @ts-expect-error: strict-null-checks
  return <CreateReturn setBackHandler={setBackHandler} settings={settings} />;
});
